/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import { ParseError } from '../parse_util';
/**
 * An i18n error.
 */
export var I18nError = (function (_super) {
    __extends(I18nError, _super);
    /**
     * @param {?} span
     * @param {?} msg
     */
    function I18nError(span, msg) {
        _super.call(this, span, msg);
    }
    return I18nError;
}(ParseError));
//# sourceMappingURL=parse_util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/compiler/src/i18n/parse_util.js
// module id = 130
// module chunks = 0